import type { ReactNode } from 'react';

/**
 * Inline alert banner. Replaces the 5+ duplicated `text-sm text-red-700 bg-
 * red-50 border border-red-200 ...` snippets for error surfaces. Info /
 * warning variants reserved for future screens.
 */

export type AlertTone = 'error' | 'info' | 'warning' | 'success';

export interface AlertProps {
  tone?: AlertTone;
  children: ReactNode;
  testId?: string;
}

const TONE: Record<AlertTone, string> = {
  error: 'text-red-700 bg-red-50 border-red-200',
  info: 'text-blue-700 bg-blue-50 border-blue-200',
  warning: 'text-amber-700 bg-amber-50 border-amber-200',
  success: 'text-emerald-700 bg-emerald-50 border-emerald-200',
};

export default function Alert({ tone = 'error', children, testId }: AlertProps) {
  return (
    <div
      role="alert"
      data-testid={testId}
      className={`text-sm border rounded px-3 py-2 ${TONE[tone]}`}
    >
      {children}
    </div>
  );
}
